import { CalculationPayload, CalculationResponse } from '@price-for-profit/micro-services';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';

export function useExecuteModel<I, O>(modelId: string) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<CalculationResponse<O>, Error, CalculationPayload<I>>(
    request => quoteService.calculate<I, O>({ modelId, payload: request }),
    {
      onError: () => {
        enqueueSnackbar(`There was a problem getting prices from model: ${modelId}`, { variant: 'error' });
      },
    }
  );
  return mutation;
}
